import Delegate from 'ftdomdelegate'

export default class NewsletterPopupSection {
  constructor(element) {
    this.element = element;
    this.delegateElement = new Delegate(this.element);
    this.options = JSON.parse(element.getAttribute('data-section-settings'));

    // If the popup has been already displayed, we do not display it
    try {
      if (window.location.hash === '#newsletter-popup' && window.theme.template !== null) {
        this._openPopup();
      } else if (!this.options['showOnlyOnce'] || this.options['showOnlyOnce'] && localStorage.getItem('themePopup') === null) {
        setTimeout(this._openPopup.bind(this), this.options['apparitionDelay'] * 1000);
      }
    } catch (error) {
      // Some browsers (especially in private mode) throw an exception when trying to access local storage, so we protect ourselves here
    }

    this._attachListeners(); 
  }

  onUnload() {
    this.delegateElement.off();
  }
  onSelect() {
    this._openPopup();
  }
  onDeselect() {
    this._closePopup();
  }
  _attachListeners() {
    this.delegateElement.on('click', '[data-action="close-popup"]', this._closePopup.bind(this));
  }
  _openPopup() {
    this.element.setAttribute('aria-hidden', 'false');
    localStorage.setItem('themePopup', 'true');
  }
  _closePopup() {
    this.element.setAttribute('aria-hidden', 'true');
  }
}